/**
 * Convertit un code pays (ex: 'be', 'fr') en emoji de drapeau
 * @param {string} countryCode - Code pays ISO (2 lettres, ex: 'be', 'fr', 'ch', 'ca')
 * @returns {string} - Emoji du drapeau ou icône de localisation par défaut
 */
export const getCountryFlag = (countryCode) => {
  if (!countryCode) return '📍'; // Default pin icon

  const codePoints = countryCode
    .toUpperCase()
    .split('')
    .map((char) => 0x1f1e6 + char.charCodeAt(0) - 'A'.charCodeAt(0));
  
  try {
    return String.fromCodePoint(...codePoints);
  } catch (error) {
    // Fallback for unsupported country codes or environments
    return '📍';
  }
};

